import React, { useState } from 'react';
import ButtonOption from './button-option';

function ButtonOptionSelector({ name, options, handleChange, id, selected }) {
  const [labelLine, setLabelLine] = useState();
  const setSelectedValue = () => {
    if (Object.keys(selected).length !== 0){
      const [_selectedOption] = options.filter(option => option.value === Object.values(selected[id])[0])
      setSelectedOption(_selectedOption)
    } else {
      setDefaultValue();
    }
  }
  const setDefaultValue = () => {
    const [_defaultOption] = options.filter(option => option.is_default === true);
    setLabelLine(_defaultOption.name);
    handleChange(id, _defaultOption.value, _defaultOption.asset);
    return _defaultOption;
  }
  const [selectedOption, setSelectedOption] = useState(selected)

  React.useEffect(() => {
    setSelectedValue();
  }, [selected])

  const handleOptionOnMouseEnter = label => {
    setLabelLine(label);
  };

  const handleOptionOnMouseLeave = () => {
    if (Object.entries(selectedOption).length !== 0){
      setLabelLine(selectedOption.name);
    }
  };

  const handleOnChangeOptions = (value, asset) => {
    handleChange(id, value, asset);
  };

  const $options = options.map(option => {
    return (
      <ButtonOption
        name={option.name}
        value={option.value}
        handleOptionOnMouse={handleOptionOnMouseEnter}
        handleOptionOnMouseLeave={handleOptionOnMouseLeave}
        handleChange={handleOnChangeOptions}
        key={option.name}
        disabled={false}
        id={option.id}
        selected={selectedOption.value === option.value}
        asset={option.asset}
      />
    );
  });
  return (
    <>
      <div className="d-flex align-content-center title-and-value mw-100">
        <strong className="title">
          <span>{name}</span>:
        </strong>
        <span className="value text-truncate">
          <span>{labelLine}</span>
        </span>
      </div>
      <ul className="list-inline">{$options}</ul>
    </>
  );
}

export default ButtonOptionSelector;
